module.exports = __webpack_public_path__ + "img/logo-white.c44faf55.png";